import { websiteEnv } from './website-env';

export const COLORS_FAMILY_KEY = websiteEnv.isUnitedKingdom ? 'colours-family' : 'colors-family';
